
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { Icon } from "leaflet";
import L from "leaflet";
import axios from "axios";
import { gps } from "@/config/host.config";
import StandartModal from "@/components/app/standart-modal.vue";

type D = Icon.Default & { _getIconUrl?: string };
delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

@Component({
  components: {
    StandartModal,
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
  },
})
export default class MapPointPicker extends Vue {
  @Prop({ type: Number, default: 0 }) latitude!: number;
  @Prop({ type: Number, default: 0 }) longitude!: number;
  @Prop({ type: String, default: "mapPointPicker" }) uid!: string;

  url = gps.osmTile;
  attribution =
    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  zoom = 11;
  center: number[] = [55, 37];
  picked: number[] | null = null;
  modalVisible = false;
  map!: L.Map;

  $refs!: { map: LMap };

  get modalId(): string {
    return `map-point-picker-${this.uid}`;
  }

  open(): void {
    if (this.latitude && this.longitude) {
      this.center = [this.latitude, this.longitude];
      this.picked = [this.latitude, this.longitude];
    }
    this.modalVisible = true;
    this.$nextTick(() => this.$bvModal.show(this.modalId));
  }

  private onModalShown(_: any, modalId: string): void {
    if (modalId !== this.modalId) return;
    this.$nextTick(() => {
      if (!this.map && this.$refs.map) {
        this.initMap();
      }
      setTimeout(() => {
        if (this.map) {
          this.map.invalidateSize();
          if (this.picked) {
            this.map.setView(this.picked as [number, number], this.zoom);
          }
        }
      }, 150);
    });
  }

  mounted(): void {
    this.$root.$on("bv::modal::shown", this.onModalShown);
  }

  beforeDestroy(): void {
    this.$root.$off("bv::modal::shown", this.onModalShown);
  }

  reset(): void {
    this.picked = null;
    this.map = null as any;
    this.modalVisible = false;
  }

  private initMap(): void {
    this.map = this.$refs.map.mapObject;
    this.map.attributionControl.setPrefix("Filoxenia");
    this.map.on("click", (event: L.LeafletMouseEvent) => {
      this.picked = [event.latlng.lat, event.latlng.lng];
    });
  }

  async getShipCoords(): Promise<void> {
    try {
      const res = await axios.get(gps.mainAPI);
      if (res.status === 200) {
        this.center = [res.data.latitude, res.data.longitude];
        this.picked = [res.data.latitude, res.data.longitude];
      }
    } catch (e) {
      console.error(e);
    }
  }

  confirm(): void {
    if (!this.picked) return;
    this.$emit("picked", { lat: this.picked[0], lng: this.picked[1] });
    this.$bvModal.hide(this.modalId);
  }
}
